/*
  Site Header
 */

var SiteHeader = (function ($) {
  var m = (function () {
    var name = 'Site Header';
    var version = '0.0.1';
    var sizeObserver = null;
    var visibilityObserver = null;
    var observerAttached = false;

    /*
      Local variable declarations
    */

    /*
      Handlers
    */
    var handlers = {
      updateFixedHeaderOffset: function () {
        var $body = $('body');
        var $siteHeader = $('#shopify-section-header');

        if (!$siteHeader.length) {
          return;
        }

        $siteHeader.addClass('is-fixed');

        $body.css({
          'padding-top': $siteHeader.outerHeight() || 0
        });
      },
      setUpFixedHeader: function () {
        var $siteHeader = $('#shopify-section-header');
        var counter = 0;

        if (!$siteHeader.length) {
          return;
        }

        handlers.updateFixedHeaderOffset();

        // Track runtime header height changes (for example, announcement bar show/hide).
        if (!observerAttached) {
          if (window.ResizeObserver) {
            sizeObserver = new ResizeObserver(function () {
              handlers.updateFixedHeaderOffset();
            });
            sizeObserver.observe($siteHeader.get(0));
            observerAttached = true;
          }
          else if (window.MutationObserver) {
            visibilityObserver = new MutationObserver(function () {
              handlers.updateFixedHeaderOffset();
            });

            visibilityObserver.observe($siteHeader.get(0), {
              attributes: true,
              childList: true,
              subtree: true,
              attributeFilter: ['style', 'class']
            });

            observerAttached = true;
          }
        }

        var interval = setInterval(function () {
          handlers.updateFixedHeaderOffset();

          if (counter >= 10) {
            clearInterval(interval);
          }

          counter++;
        }, 500);
      },
    };

    /*
      List handlers that should be
      accessible in the global namespace
    */
    var publicHandlers = [
    ];

    /*
      Events
    */
    var events = {
      onResize: function () {
        $(window).on('resize', function () {
          handlers.setUpFixedHeader();
        });
      },
      pageLoad: function () {
        handlers.setUpFixedHeader();
      },
    };

    /*
      List events in the order they
      should be bound. Any unlisted
      events will be registered last.
    */
    var eventOrder = [
      'pageLoad',
    ];

    /************************************************************************************
      DON'T EDIT BELOW THIS LINE
    ************************************************************************************/

    var bindEvents = function () {
      var eventNames = Object.keys(events);
      for (var i = 0; i < eventNames.length; i++) {
        var eventName = eventNames[i];
        if (eventOrder.indexOf(eventName) < 0) {
          eventOrder.push(eventName);
        }
      }

      for (var i = 0; i < eventOrder.length; i++) {
        var eventName = eventOrder[i];
        var event = events[eventName];

        if (event !== undefined) {
          if (typeof (event) === 'function') {
            try {
              event();
            }
            catch (e) {
              console.error('Event binding failed: ' + eventName);
              console.error(e);
            }
          }
          else {
            console.error('Event is not a function: ' + eventName);
          }
        }
        else {
          console.error('Event is undefined: ' + eventName);
        }
      }
    };

    var registerPublicHandlers = function () {
      for (var i = 0; i < publicHandlers.length; i++) {
        var handlerName = publicHandlers[i];
        var handler = handlers[handlerName];
        if (handler !== undefined) {
          if (typeof (handler) === 'function') {
            interface[handlerName] = handler;
          }
          else {
            console.error('Handler is not a function: ' + handlerName);
          }
        }
        else {
          console.error('Handler is undefined: ' + handlerName);
        }
      }
    };

    var interface = {
      _init_: function () {
        registerPublicHandlers();
        bindEvents();
        delete interface._init_;
      },
      toString: function () {
        return name + ' (version ' + version + ')';
      },
    };

    return interface;
  }());

  // Error-safe initialization
  $(function () {
    try {
      m._init_();
    }
    catch (e) {
      console.error('Module failed to initialize: ' + m);
      console.error(e);
    }
  });

  return m;
}(jQuery));
